import { AsideMenuHyperLink } from "../../../../layout/components/aside/AsideMenuItem"
import { IPageAction } from "../../../base/models"
import { Property } from "../../../base/types"
import { useGetProperties } from "../../../base/hooks"

export const AsideMenuActionLink = ({ action, hasBullet, className }: {
    action: IPageAction,
    hasBullet: boolean
    className?: string
}) => {
    const { properties } = useGetProperties({ bindings: action.bindings });
    const pageUrl: string | undefined = properties[Property.Url];
    const target: string | undefined = properties[Property.Target];

    if (!pageUrl)
        return <></>

    return (
        <AsideMenuHyperLink
            hasBullet={hasBullet}
            className={className}
            to={pageUrl}
            target={target}
            materialIcon={action.icon}
            title={action.name}
            fontIcon='bi-app-indicator'
        />)
}